import clone from 'lodash-es/clone';

/**
 * Permite escribir una propiedad en un objeto, en una ruta especificada. Si
 * dicha ruta no existe dentro del objeto la crea, siempre que sea posible. No
 * será posible en caso de que alguno de los elementos de la ruta contenga una
 * propiedad que no sea de tipo objeto.
 *
 * @param obj El objeto donde se desea escribir la propiedad
 * @param path La ruta en la que se va a escribir
 * @param value El valor que se va a escribir en la ruta especificada
 * @returns Un objeto idéntico del recibido pero co nlos cambios aplicados
 *
 * @throws { Error } En caso de que la ruta especificada contenga algún elemento que no puede ser escrito.
 *
 * @example
 *
 * const a = {
 *  a: {}
 * };
 *
 * setValueByPath(a, 'a.b.c', 'Hello world');
 * /* Outputs:
 * {
 *  a: {
 *    b: {
 *      c: 'Hello world'
 *    }
 *  }
 * }
 */
export function setValueByPath<T extends object>(
  obj: T,
  path: string,
  value: unknown,
): T | null {
  if (path === '') return value as T;

  const steps = path.split('.');
  if (steps.length === 0) {
    console.warn(`An empty path was provoided ${path}`);
    return null;
  }
  const originalClonedObject = clone(obj ?? {});
  let currentObj = originalClonedObject;
  for (let i = 0; i < steps.length - 1; i++) {
    if (!(currentObj as any)[steps[i]]) (currentObj as any)[steps[i]] = {};
    if (typeof (currentObj as any)[steps[i]] === 'object') {
      currentObj = (currentObj as any)[steps[i]];
    } else {
      console.info({
        originalObject: obj,
        originalPath: path,
        currentObj,
        currentStep: steps[i],
      });
      throw new Error(
        `The provided path ${path} cannot be applied due to it is not an object's path.`,
      );
    }
  }
  (currentObj as any)[steps.pop() as string] = value;
  return originalClonedObject as T;
}
